@if (allaSkogsvardBetalningar.length > 0) {
<div class="skogsvard-container pb-3">
    <div class="skogsvard-table-header gray">
        <div class="fardigplanerad-col label">
            Färdigplanerad skogsvård
        </div>
        <div class="kostnader-col label">
            kostnader
        </div>
    </div>
    <div>
        <ng-container>
            <div
                (click)="isCollapsed = !isCollapsed"
                class="skogsvard-header skogsvard-table-header">
                <div class="fardigplanerad-col">
                    {{getSkogvardsgrupper()}}
                </div>
                <div class="kostnader-col d-flex">
                    {{getSkogvardstyper()}}
                    <div class="ms-auto">
                        <i class="fa-solid"
                            [ngClass]="{ 'fa-chevron-down': isCollapsed, 'fa-chevron-up': !isCollapsed }"></i>
                    </div>
                </div>
            </div>
            <div [(ngbCollapse)]="isCollapsed">

                @if (!isCollapsed && legacyLockedMessage?.length) {
                    <div class="col-12">
                    <div class="grotvolym-message-container">
                        <rask-message-panel
                            [items]="legacyLockedMessage">
                        </rask-message-panel>
                    </div>
                    </div>
                }

                @for (skogsvardgruppInfo of skogsvardsGruppersInfo; track skogsvardgruppInfo.grupp) {
                <div class="row">
                    <div class="col">
                        <rask-header size="4">{{getHeaderNamn(skogsvardgruppInfo)}}</rask-header>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col border-top"></div>
                </div>
                <div class="row py-3">
                    <div class="col ps-4">
                        @if (skogsvardgruppInfo.atgarder && skogsvardgruppInfo.atgarder.length) {
                        <div>
                            @for (atgard of skogsvardgruppInfo.atgarder; track trackById($index, atgard); let last =
                            $last) {
                            <span class="atgard-link">
                                <a
                                    [routerLink]="[]"
                                    [queryParams]="{ kontraktId: virkeskopsKontrakt.id , atgardId: atgard.id}"
                                    (click)="navigateTo(atgard.id, $event)">
                                    {{atgard.beteckning}}
                                </a>
                                {{ atgard.onskatDatum ? ' (' + formatDateMonthString(atgard.onskatDatum) + ')' :
                                ''}}
                                @if (!last) {
                                ,
                                }
                            </span>
                            }
                        </div>
                        }
                    </div>
                </div>
                <div class="skogsvard-betalning-table-container">
                    @if (skogsvardgruppInfo.betalningar && skogsvardgruppInfo.betalningar.length) {
                    <rask-list
                        [data]="skogsvardgruppInfo.betalningar"
                        [showHeaderWhenEmpty]="true">
                        <rask-list-column header="Betalning" field="betalningstyp" [minWidth]="'110px'"
                            [width]="'110px'">
                            <ng-template let-row="row">
                                @if (row.canChangeRow) {
                                <rask-icon-button
                                    class="icon-skogsvard-betalning-table"
                                    [ngbPopover]="betalningstypPopover"
                                    #popoverbetalningstyp="ngbPopover"
                                    placement="right-top"
                                    autoClose="outside"
                                    icon="fa-regular fa-pen-to-square"
                                    [disabled]="isDirty || kontraktReadonly || row.isVacsRad">
                                </rask-icon-button>
                                <ng-template #betalningstypPopover>
                                    <div class="skogsvard-betalning-popover" [id]="'betalningstyp-popover-' + row.id">
                                        <div>
                                            <rask-header size="4">Betalningstyp
                                                {{row.betalningsTyp}}</rask-header>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col">
                                                <rask-simple-selector
                                                    #betalningsTyp
                                                    class="mt-1"
                                                    label="Välj betalningstyp"
                                                    (ngModelChange)="betalningstypChanged($event)"
                                                    [values]="row.betalningSelectItems"
                                                    [ngModel]="row.betalningstyp"
                                                    [disabled]="row.betalformDisabled || row.disabled || row.isVacsRad"
                                                    bindLabel="text"
                                                    bindValue="value"
                                                    [clearable]="false">
                                                </rask-simple-selector>
                                            </div>
                                        </div>
                                        @if (betalningsTyp.selected) {
                                        <div class="row ms-1">
                                            <div class="col-1">
                                                <i class="fa-sharp fa-regular fa-circle-info"></i>
                                            </div>
                                            <div class="col ps-1">
                                                {{ getBetalningInfoText(betalningsTyp.selected) }}
                                            </div>
                                        </div>
                                        }
                                        <div class="row mt-4">
                                            <div class="col">
                                                <rask-button color="primary"
                                                    (click)="saveBetalningstyp(row.id, betalningsTyp.value, popoverbetalningstyp)"
                                                    [disabled]="!betalningstypEdited">
                                                    Spara
                                                </rask-button>
                                                <rask-button color="secondary"
                                                    (click)="cancel(popoverbetalningstyp)">
                                                    Avbryt
                                                </rask-button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                }
                                <span class="betalningstyp-text"
                                    [ngClass]="{'skogsvard-betalning-margin-left-icon': !row.canChangeRow}">
                                    {{row.betalningstyp}}
                                </span>
                            </ng-template>
                        </rask-list-column>
                        <rask-list-column header="Åtgärd" field="atgardstypVacs" [minWidth]="'148px'"
                            [width]="'148px'">
                            <ng-template let-row="row">
                                <span>{{row.atgardstypVacs}}</span><br />
                                <span>{{row.virkeskopsatgardBeteckning}}</span>
                            </ng-template>
                        </rask-list-column>
                        <rask-list-column header="Kvant" field="kvantitet" [minWidth]="'80px'" [width]="'80px'">
                            <ng-template let-row="row">
                            @if (!row.hideKvantitet) {
                                @if (row.justeringMojlig) {
                                <rask-icon-button
                                    class="icon-skogsvard-betalning-table"
                                    [ngbPopover]="kvantitetPopover"
                                    #popoverKvantitet="ngbPopover"
                                    placement="right-top"
                                    [autoClose]="'outside'"
                                    icon="fa-sharp fa-solid fa-money-check-dollar-pen"
                                    [disabled]="isDirty">
                                </rask-icon-button>
                                <ng-template #kvantitetPopover>
                                    <div class="skogsvard-betalning-popover">
                                        <div>
                                            <rask-header size="4">Kvantitet {{row.atgardstypVacs}}</rask-header>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <rask-input-number
                                                    #kvantitet
                                                    label="Kvantitet"
                                                    [ngModel]="row.kvantitet"
                                                    class="apris-popover-width mt-1"
                                                    (ngModelChange)="kvantitetChanged($event)"
                                                    [isNegative]="false"
                                                    [useDecimalProcessor]="true">
                                                </rask-input-number>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <rask-button color="primary"
                                                    (click)="saveKvantitet(row.id, kvantitet.value, popoverKvantitet)"
                                                    [disabled]="!kvantitetEdited">
                                                    Spara
                                                </rask-button>
                                                <rask-button color="secondary"
                                                    (click)="cancel(popoverKvantitet)">
                                                    Avbryt
                                                </rask-button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                }
                            }
                            {{row.kvantitet | number: '1.0-2': 'sv'}}
                            </ng-template>
                        </rask-list-column>
                        <rask-list-column header="Måttslag" field="mattslag" [minWidth]="'80px'" [width]="'80px'">
                            <ng-template let-row="row">
                                {{row.mattslag}}
                                @if (row.canChangeRow && row.canChangeMattslag) {
                                <rask-icon-button
                                    class="icon-skogsvard-betalning-table"
                                    [ngbPopover]="mattslagPopover"
                                    #popovermattslag="ngbPopover"
                                    placement="bottom"
                                    autoClose="outside"
                                    icon="fa-regular fa-chevron-down"
                                    [disabled]="isDirty || kontraktReadonly">
                                </rask-icon-button>
                                <ng-template #mattslagPopover>
                                    <div class="skogsvard-betalning-popover" [id]="'mattslag-popover-' + row.id">
                                        <div>
                                            <rask-header size="4">Måttslag {{row.mattslag}}</rask-header>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <rask-simple-selector
                                                    #mattslag
                                                    class="mt-1"
                                                    (ngModelChange)="mattslagChanged($event)"
                                                    [values]="selectMattslag"
                                                    [ngModel]="row.mattslag"
                                                    [clearable]="false">
                                                </rask-simple-selector>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <rask-button color="primary"
                                                    (click)="saveMattslag(row.id, mattslag.value, popovermattslag)"
                                                    [disabled]="!mattslagChanged">
                                                    Spara
                                                </rask-button>
                                                <rask-button color="secondary"
                                                    (click)="cancel(popovermattslag)">
                                                    Avbryt
                                                </rask-button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                }
                            </ng-template>
                        </rask-list-column>
                        <rask-list-column header="Á-pris" field="apris" [minWidth]="'90px'" [width]="'90px'">
                            <ng-template let-row="row">
                                @if (row.canChangeRow) {
                                <rask-icon-button
                                    class="icon-skogsvard-betalning-table"
                                    [ngbPopover]="aprisPopover"
                                    #popoverApris="ngbPopover"
                                    placement="right-top"
                                    autoClose="outside"
                                    icon="fa-regular fa-pen-to-square"
                                    [disabled]="isDirty || kontraktReadonly">
                                </rask-icon-button>
                                <ng-template #aprisPopover>
                                    <div class="skogsvard-betalning-popover">
                                        <div>
                                            <rask-header size="4">Á-pris {{row.atgardstypVacs}}</rask-header>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <rask-input-number
                                                    #aPris
                                                    label="Á-pris"
                                                    [ngModel]="row.apris"
                                                    class="popover-width mt-1"
                                                    (ngModelChange)="aprisChanged($event)"
                                                    [isNegative]="false"
                                                    [max]="99999"
                                                    [useDecimalProcessor]="true">
                                                </rask-input-number>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <rask-button color="primary"
                                                    (click)="saveApris(row.id, aPris.value, popoverApris)"
                                                    [disabled]="!aprisEdited">
                                                    Spara
                                                </rask-button>
                                                <rask-button color="secondary"
                                                    (click)="cancel(popoverApris)">
                                                    Avbryt
                                                </rask-button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                }
                                <span class="apris-text"
                                    [ngClass]="{'skogsvard-betalning-margin-left-icon': !row.canChangeRow}">
                                    {{row.apris | number: '1.0-2': 'sv'}}
                                </span>
                            </ng-template>
                        </rask-list-column>
                        <rask-list-column header="Belopp" [minWidth]="'100px'" width="'100px'">
                            <ng-template let-row="row" class="belopp-col">
                                @if (row.canChangeBelopp) {
                                <rask-icon-button
                                    class="icon-skogsvard-betalning-table"
                                    [ngbPopover]="beloppPopover"
                                    #popoverBelopp="ngbPopover"
                                    placement="right-top"
                                    [autoClose]="'outside'"
                                    icon="fa-regular fa-pen-to-square"
                                    [disabled]="isDirty">
                                </rask-icon-button>
                                <ng-template #beloppPopover>
                                    <div class="skogsvard-betalning-popover">
                                        <div>
                                            <rask-header size="4">Belopp {{row.atgardstypVacs}}</rask-header>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <rask-input-number
                                                    #belopp
                                                    label="Belopp"
                                                    [ngModel]="row.belopp"
                                                    class="popover-width mt-1"
                                                    (ngModelChange)="beloppChanged($event)"
                                                    [isNegative]="false"
                                                    [useDecimalProcessor]="true">
                                                </rask-input-number>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <rask-button color="primary"
                                                    (click)="saveBelopp(row.id, belopp.value, popoverBelopp)"
                                                    [disabled]="!beloppEdited">
                                                    Spara
                                                </rask-button>
                                                <rask-button color="secondary"
                                                    (click)="cancel(popoverBelopp)">
                                                    Avbryt
                                                </rask-button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                }
                                <span class="belopp-col">
                                    @if(row.calculateBelopp) {
                                    {{calculateBelopp(row) | number: '1.0-2': 'sv'}}
                                    } @else {
                                    {{row.belopp | number: '1.0-2': 'sv'}}
                                    }
                                </span>
                            </ng-template>
                        </rask-list-column>
                        @if(!isLegacySkogsvard()){
                            <rask-list-column header="Kontrakt" [minWidth]="'80px'" [width]="'80px'">
                                <ng-template let-row="row">
                                    @if (row.hasKontrakteradeValues){
                                        <rask-icon icon="far fa-file-contract" popoverTriggers="raskDefault">
                                            <span>Kontrakterad kvantitet: <span class="{{row.kontrakteratKvantitetCssClass}}">{{row.kontrakteradKvantitet | number: '1.0-2': 'sv'}}</span></span><br />
                                            <span>Kontrakterat apris: <span class="{{row.kontrakteratAprisCssClass}}">{{row.kontrakteratApris | number: '1.0-2': 'sv'}}</span></span><br />
                                            @if(!!row.kontrakteratBelopp){
                                                <span>Kontrakterat belopp: <span class="{{row.kontrakteratBeloppCssClass}}">{{row.kontrakteratBelopp | number: '1.0-2': 'sv'}}</span></span>
                                            }
                                        </rask-icon>
                                    }
                                </ng-template>
                            </rask-list-column>
                        }
                        <rask-list-column header="Anteckning" field="anteckningIntern" [minWidth]="'80px'">
                            <ng-template let-row="row">
                                <div class="ellipsis-anteckning">
                                    @if (row.canChangeRow) {
                                    <rask-icon-button
                                        class="icon-skogsvard-betalning-table"
                                        container="body"
                                        (click)="openComment(row.id, row.anteckningIntern)"
                                        icon="{{row.anteckningIntern?.length ? 'fa-solid' : 'fa-regular'}} fa-comment"
                                        [disabled]="isDirty || kontraktReadonly">
                                    </rask-icon-button>
                                    }
                                    <span
                                        [ngbPopover]="row.anteckningIntern"
                                        #popoverKvantitet="ngbPopover"
                                        triggers="mouseenter:mouseleave"
                                        [ngClass]="{'skogsvard-betalning-margin-left-icon-anteckning': !row.canChangeRow}"
                                        class="comment-text">
                                        {{row.anteckningIntern}}
                                    </span>
                                </div>
                            </ng-template>
                        </rask-list-column>

                        @if(isLegacySkogsvard()){
                        <rask-list-column header="Datum tillagd" field="datumTillagd" [minWidth]="'100px'">
                            <ng-template let-row="row">
                                {{formatDateString(row.datumTillagd)}}
                            </ng-template>
                        </rask-list-column>
                        } @else {
                        <rask-list-column header="Skickad till vacs" field="skickadTillVacs" [minWidth]="'100px'">
                            <ng-template let-row="row">
                                {{formatDateString(row.skickadTillVacs)}}
                            </ng-template>
                        </rask-list-column>
                        }
                    </rask-list>
                    }
                    <div class="row rowfooter mb-4">
                        <table>
                            <tr>
                                <td style="min-width: 110px; width:110px" class="svea-text">
                                    <span>Summa</span>
                                </td>
                                <td style="min-width: 148px;width:140px" class="svea-text"></td>
                                <td style="min-width: 80px;width:80px" class="svea-text"></td>
                                <td style="min-width: 80px;width:70px" class="svea-text"></td>
                                <td style="min-width: 90px;width:90px" class="svea-text"></td>
                                <td style="min-width: 100px;" class="svea-text">
                                    {{calculateSum(skogsvardgruppInfo.betalningar) | number: '1.0-2': 'sv'}}
                                </td>
                                <td style="min-width: 80px;" class="svea-text"></td>
                                <td style="min-width: 100px;" class="svea-text"></td>
                            </tr>
                        </table>
                    </div>
                </div>
                }
            </div>
        </ng-container>
    </div>
</div>
}